const ITEMS = [
  "MOBILE INTERIOR DETAILING",
  "WE COME TO YOU",
  "BASIC CLEAN $60",
  "PREMIUM CLEAN $80",
  "TEXT 405-655-9536",
  "METRO AREA",
];

export const EditorialMarquee = () => {
  const row = [...ITEMS, ...ITEMS].map((t) => `${t}  •  `).join("");
  return (
    <div className="overflow-hidden border-y border-[#E5E7EB] bg-[#F3F2EC] py-4" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max whitespace-nowrap">
        <span className="font-mono-alt text-xs font-medium tracking-[0.25em] text-[#6B7280]">{row}</span>
        <span className="font-mono-alt text-xs font-medium tracking-[0.25em] text-[#6B7280]">{row}</span>
      </div>
    </div>
  );
};
